module.exports = __webpack_public_path__ + "img/グループ 225.6328fe01.png";